/*
import axios from 'axios'
import config from '../settings/bananas'

const header = {
  'Content-Type': 'application/json'
}

let trackingUrl = config.tracking.url

if (window.location.hostname === 'localhost') {
  trackingUrl = 'http://localhost:3000'
}
*/

export default {
  trackView(viewData, instance) {
    /*
    viewData.userId = instance.$store.getters.getUniqueId
    axios.post(
      trackingUrl + '/tracking/bn/view/',
      viewData,
      {
        headers: header
      }
    ).then(function (response) {
      return response.data
    })
    */
  },
  getAllViews() {
    /*
    axios.post(
      trackingUrl + '/tracking/bn/view/get/all',
      {},
      {
        headers: header
      }
    ).then(function (response) {
      return response.data
    })
    */
  }
}
